import { createSlice } from '@reduxjs/toolkit';
import { FETCH_STATUS } from '../../types/enums/fetch-status.enum';
import { FullServiceInstallationReportList } from '../../types/telcobill/full-service-installation-report.type';
import { getFullServiceInstallationReport } from './fullServiceInstallationReport.action';
import snackbarUtils from '../../utils/SnackbarUtils';

export interface FullServiceInstallationReportState {
  list: FullServiceInstallationReportList | null;
  fetchStatus: FETCH_STATUS;
}

const INITIAL_STATE: FullServiceInstallationReportState = {
  list: null,
  fetchStatus: FETCH_STATUS.NULL,
};

export const fullServiceInstallationReportSlice = createSlice({
  name: 'fullServiceInstallationReport',
  initialState: INITIAL_STATE,
  reducers: {
    resetFullServiceInstallationReport: () => INITIAL_STATE,
  },
  extraReducers: builder => {
    builder
      .addCase(getFullServiceInstallationReport.pending, state => {
        state.fetchStatus = FETCH_STATUS.PENDING;
      })
      .addCase(getFullServiceInstallationReport.fulfilled, (state, action) => {
        state.fetchStatus = FETCH_STATUS.FULFILLED;
        state.list =
          action.payload ?? ({
            items: [],
            meta: {
              totalItems: 0,
              totalPages: 1,
              filterOptions: { customerNames: [], locations: [], shippedBys: [] },
            },
          } as FullServiceInstallationReportList);
      })
      .addCase(getFullServiceInstallationReport.rejected, (state, action) => {
        state.fetchStatus = FETCH_STATUS.REJECTED;
        state.list = {
          items: [],
          meta: {
            totalItems: 0,
            totalPages: 1,
            filterOptions: { customerNames: [], locations: [], shippedBys: [] },
          },
        };

        setTimeout(() => {
          snackbarUtils.error(
            (action.payload as string) || 'Failed to load TelcoBill Full Service Installation Report.',
          );
        });
      });
  },
});

export const { resetFullServiceInstallationReport } = fullServiceInstallationReportSlice.actions;
export default fullServiceInstallationReportSlice.reducer;

